import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';

import InstallerContext from "@/context/InstallerContext";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft, faAngleRight} from "@fortawesome/free-solid-svg-icons";

import {getLocation} from "@/lib/utils";

import logo from '@/images/leaderos-icon.png';

const LicenseVerification = () => {
  const domain = window.location.hostname;
  const protocol = window.location.protocol.replace(':', '');
  const loginUrl = getLocation() === "TR" ? `https://www.leaderos.com.tr/api-keys/installer?type=auto&protocol=${protocol}&domain=${domain}` : `https://www.leaderos.net/api-keys/installer?type=auto&protocol=${protocol}&domain=${domain}`;
  const {setWelcome} = useContext(InstallerContext);
  
  const previousStep = () => setWelcome(true);
  const {t} = useTranslation();
  
  return (
      <div className="w-full my-auto flex flex-col items-center justify-center">
        <div className="-mt-16">
          <img src={logo} alt="" className="w-32"/>
        </div>
        <h1 className="text-gray-800 mt-6 text-3xl font-bold text-center">
          {t('license_verification.title')}
        </h1>
        <p className="text-gray-400/75 max-w-xl text-lg text-center mt-3">
          {t('license_verification.description')}
        </p>
        <div className="flex mt-16 w-full md:w-1/3 px-4 md:px-0">
          <div className="w-full flex justify-between gap-3">
            <div onClick={previousStep} className="cursor-pointer rounded-xl py-3 px-6 flex gap-3 bg-gray-400/[10%] text-gray-600/75 items-center font-medium group transition hover:bg-gray-400/25 hover:text-gray-500">
              <div
                  className="w-10 h-10 flex items-center justify-center rounded-xl bg-gray-300/75 group-hover:bg-gray-400 transition">
                <FontAwesomeIcon icon={faAngleLeft} className="text-xl group-hover:text-white transition"/>
              </div>
              {t('prev')}
            </div>
            <a href={loginUrl} className="min-w-40 rounded-xl bg-vox/[10%] py-3 px-6 flex justify-end x gap-3 items-center text-vox/75 font-medium group transition hover:bg-vox/25 hover:text-vox cursor-pointer">
              {t('license_verification.verify')}
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-vox/25 group-hover:bg-vox transition">
                <FontAwesomeIcon icon={faAngleRight} className="text-xl group-hover:text-white transition"/>
              </div>
            </a>
          </div>
        </div>
      </div>
  );
};

export default LicenseVerification;